//
// This file is AUTO-GENERATED by protoc-gen-ts.
// Do not modify it manually.
///
import api from '../../api'
import * as googleTypes from '../../googleTypes'
import { Money as arangodb_cloud_internal_common_v1_Money } from '../../common/v1/icommon'
import { ListUsageItemsRequest as arangodb_cloud_usage_v1_ListUsageItemsRequest } from './usage'
import { UsageItem as arangodb_cloud_usage_v1_UsageItem } from './usage'

// File: usage/v1/iusage.proto
// Package: arangodb.cloud.internal.usage.v1

// Billing 2.0 credit consumption of all organizations in a period.
export interface AllOrganizationsCreditUsage {
  // One item per organization (or per deployment if group_by_deployment was set),
  // ordered descending by total_credits.
  // OrganizationCreditUsage
  items?: OrganizationCreditUsage[];
  
  // Total credits consumed over the whole requested period, by all items.
  // number
  total_credits?: number;
}

// Response for ClearUsageItemPrice.
export interface ClearUsageItemPriceResponse {
  // Number of usage items for which the price was reset.
  // number
  reset_usage_items?: number;
  
  // Number of usage items that were selected but not reset because they were
  // already used in a verified invoice.
  // number
  skipped_usage_items?: number;
}

// Credits consumed by a single usage component.
export interface ComponentCreditUsage {
  // Usage component (usage item kind), e.g. "MemoryHour".
  // string
  component?: string;
  
  // Credits consumed.
  // number
  credits?: number;
}

// Request arguments for EndUsageItems.
export interface EndUsageItemsRequest {
  // If set and not empty, filter on UsageItem kind.
  // string
  kind?: string;
  
  // If set and not empty, filter on UsageItem resource.url.
  // string
  resource_url?: string;
}

// Request arguments for GetAllOrganizationsCreditUsage.
export interface GetAllOrganizationsCreditUsageRequest {
  // Start of the reported period (inclusive).
  // This is a required field.
  // googleTypes.Timestamp
  from?: googleTypes.Timestamp;
  
  // End of the reported period (exclusive).
  // This is a required field.
  // The period must not be longer than 366 days.
  // googleTypes.Timestamp
  to?: googleTypes.Timestamp;
  
  // Limit the report to the organization with this id.
  // This is an optional field.
  // string
  organization_id?: string;
  
  // If set, return one item per deployment instead of one item per organization.
  // This is only allowed in combination with organization_id.
  // boolean
  group_by_deployment?: boolean;
}

// ListAllUsageItemsRequest contains request arguments for ListAllUsageItems.
export interface ListAllUsageItemsRequest {
  // arangodb.cloud.usage.v1.ListUsageItemsRequest
  request?: arangodb_cloud_usage_v1_ListUsageItemsRequest;
  
  // If set to true, only include usage items where a price has been set.
  // boolean
  with_price?: boolean;
  
  // If set to true, only include usage items where a price has not been set.
  // boolean
  without_price?: boolean;
  
  // If set, include usage items where the tier is matching this ID.
  // string
  tier_id?: string;
  
  // If set, include only those usage items where a credit has been set.
  // boolean
  with_credits?: boolean;
  
  // If set, include only those usage items where a credit has not been set.
  // boolean
  without_credits?: boolean;
  
  // If set, exclude those usage items that are associated with a prepaid deployment.
  // boolean
  exclude_prepaid?: boolean;
  
  // If set, include only usage items whose ingestion_status is in this set (Billing 2.0).
  // Note: NOT_INGESTED is stored as a missing attribute, so usaged treats "missing" as NOT_INGESTED.
  // UsageItemIngestionStatus
  ingestion_statuses?: UsageItemIngestionStatus[];
  
  // If set, exclude usage items that have a zero quantity ("empty" items). Only affects
  // Billing 2.0 kinds; legacy kinds are never treated as empty by this filter.
  // boolean
  exclude_empty?: boolean;
  
  // If set, include only Billing 2.0 usage kinds (the set in apis BillingV2UsageItemKinds).
  // boolean
  only_billing_v2?: boolean;
}

// Billing 2.0 credit consumption of a single organization (or deployment) in a period.
export interface OrganizationCreditUsage {
  // ID of the organization.
  // string
  organization_id?: string;
  
  // ID of the deployment.
  // Empty unless group_by_deployment was set on the request.
  // string
  deployment_id?: string;
  
  // Credits consumed per usage component, ordered by component.
  // Components without consumption are omitted.
  // ComponentCreditUsage
  components?: ComponentCreditUsage[];
  
  // Total credits consumed (sum of all components).
  // number
  total_credits?: number;
  
  // Number of distinct deployments that contributed to this item.
  // number
  deployment_count?: number;
}

// Response member of StreamAllOrganizationsWithUsage
export interface OrganizationWithUsage {
  // Organization ID
  // string
  id?: string;
}

// Response for StreamAllOrganizationsWithUsage
export interface OrganizationWithUsageList {
  // OrganizationWithUsage
  items?: OrganizationWithUsage[];
}

// Request arguments for SetUsageItemCost.
export interface SetUsageItemCostRequest {
  // ID of the usage item.
  // string
  id?: string;
  
  // Billing 2.0 cost to set.
  // UsageItemCost
  cost?: UsageItemCost;
}
export interface SetUsageItemCreditBundleIDsRequest {
  // ID of the usage item.
  // string
  id?: string;
  
  // List of credit bundles that were used to pay for it.
  // string
  credit_bundle_ids?: string[];
}

// Request arguments for SetUsageItemIngestionStatus.
export interface SetUsageItemIngestionStatusRequest {
  // ID of the usage item.
  // string
  id?: string;
  
  // New ingestion status.
  // UsageItemIngestionStatus
  ingestion_status?: UsageItemIngestionStatus;
  
  // Time the item was confirmed integrated in Everest. Required when status == INTEGRATED.
  // googleTypes.Timestamp
  ingested_at?: googleTypes.Timestamp;
  
  // Everest dataExtractionId from the ingest call (optional).
  // string
  ingestion_data_extraction_id?: string;
  
  // Human-readable reason for the status. Stored as given when
  // ingestion_status is FAILED or SKIPPED and cleared for every other status,
  // so a previously failed item that succeeds does not keep a stale reason.
  // string
  ingestion_error?: string;
  
  // Everest trackId the item was sent under (optional). Set when the item is handed
  // to Everest and kept afterwards, so the row it landed on stays identifiable for
  // as long as the item exists.
  // string
  ingestion_track_id?: string;
}

// Request arguments for SetUsageItemPrice.
export interface SetUsageItemPriceRequest {
  // ID of the usage item to set the price of
  // string
  id?: string;
  
  // Price to set
  // UsageItemPrice
  price?: UsageItemPrice;
  
  // Price to set in terms of credits.
  // UsageItemPrice
  credits?: UsageItemPrice;
}

// Request arguments for SetUsageItemsInvoiceID.
export interface SetUsageItemsInvoiceIDRequest {
  // List of identifiers of usage items to set the invoice ID for.
  // string
  usage_item_ids?: string[];
  
  // Identifier of invoice to set in the usage items
  // string
  invoice_id?: string;
}

// Request arguments for SplitUsageItems.
export interface SplitUsageItemsRequest {
  // If set and not empty, filter on UsageItem kind.
  // string
  kind?: string;
  
  // If set and not empty, filter on UsageItem resource.url.
  // string
  resource_url?: string;
  
  // Required timestamp of the end time of the usage items.
  // Found usage items are ended at the given timestamp
  // and new ones are started.
  // googleTypes.Timestamp
  ends_at?: googleTypes.Timestamp;
}

// Request arguments for UpdateUsageItemsForPrepaidDeployment
// This request is send during attach/detach of deployment to prepaid deployment,
// update of prepaid deployment with deployment attached to id and before
// invoice calculation for deployment with prepaid deployment.
export interface UpdateUsageItemsForPrepaidDeploymentRequest {
  // Usage kind
  // this field is required
  // string
  kind?: string;
  
  // Usage resource url
  // this field is required
  // string
  resource_url?: string;
  
  // ID of prepaid deployment associated with usage items
  // this field is required
  // string
  prepaid_deployment_id?: string;
  
  // When the prepaid deployment starts
  // this field is required
  // googleTypes.Timestamp
  prepaid_deployment_starts_at?: googleTypes.Timestamp;
  
  // When the prepaid deployment ends
  // this field is required
  // googleTypes.Timestamp
  prepaid_deployment_ends_at?: googleTypes.Timestamp;
}

// UsageItemCost is the cost of a usage item, expressed both in credits
// (the Billing 2.0 settlement unit) and in the system currency.
export interface UsageItemCost {
  // Cost in credits.
  // arangodb.cloud.internal.common.v1.Money
  credits?: arangodb_cloud_internal_common_v1_Money;
  
  // Cost in the system default currency (e.g. USD).
  // arangodb.cloud.internal.common.v1.Money
  amount?: arangodb_cloud_internal_common_v1_Money;
}

// Internal representation of UsageItem
export interface UsageItemInfo {
  // The public usage item
  // arangodb.cloud.usage.v1.UsageItem
  usage_item?: arangodb_cloud_usage_v1_UsageItem;
  
  // Deprecated: V1 (BlueSnap) pricing breakdown. Replaced by `cost`. Removed once Billing V1 is decommissioned.
  // UsageItemPrice
  price?: UsageItemPrice;
  
  // Last time that the price for this usage item was set.
  // googleTypes.Timestamp
  price_changed_at?: googleTypes.Timestamp;
  
  // Deprecated: V1 credits breakdown. Replaced by `cost`. Removed once Billing V1 is decommissioned.
  // UsageItemPrice
  credits?: UsageItemPrice;
  
  // Billing 2.0 cost (credits + currency). Set after the item period is final.
  // UsageItemCost
  cost?: UsageItemCost;
  
  // Everest ingestion status (Billing 2.0). Defaults to NOT_INGESTED; updated by the Everest ingestion worker.
  // UsageItemIngestionStatus
  ingestion_status?: UsageItemIngestionStatus;
  
  // Time the item was confirmed integrated in Everest. Set when ingestion_status == INTEGRATED.
  // googleTypes.Timestamp
  ingested_at?: googleTypes.Timestamp;
  
  // Everest dataExtractionId from the ingest call (for traceability / status polling).
  // string
  ingestion_data_extraction_id?: string;
  
  // Human-readable reason behind the ingestion status. For FAILED: Everest's own
  // rejection message, or why the ingestion worker refused to send the item (e.g.
  // no credit plan rate). For SKIPPED: why there was nothing to send (zero usage,
  // zero-rated by the credit plan, before the ingestion window, anchor deleted
  // before it was billed). Cleared when the item leaves these statuses, so it
  // always describes the current status rather than some earlier attempt.
  // string
  ingestion_error?: string;
  
  // Everest trackId this item was sent under, echoed back on the matching
  // getIngestionStatus row. One Everest row can carry several usage items (they are
  // merged per subscription line, billable component and period, because Everest
  // replaces a row's value instead of summing), so every item of such a group shares
  // one trackId. Empty for items ingested before the field existed; those were sent
  // under their own id.
  // string
  ingestion_track_id?: string;
}

// List of UsageItemInfo's
export interface UsageItemInfoList {
  // UsageItemInfo
  items?: UsageItemInfo[];
}

// Price of a usage item.
// All amounts are expressed in default system currency and do not include any form of sales tax.
// Deprecated: V1 (BlueSnap) pricing breakdown. Use UsageItemCost for Billing 2.0. This message will be removed once Billing V1 is decommissioned.
export interface UsageItemPrice {
  // Total price. Sum of all other amounts in this message.
  // arangodb.cloud.internal.common.v1.Money
  total?: arangodb_cloud_internal_common_v1_Money;
  
  // Prices for network traffic out of the deployment
  // UsageItemPrice_NetworkPrice
  network_egress?: UsageItemPrice_NetworkPrice;
  
  // Prices for network traffic into the deployment
  // UsageItemPrice_NetworkPrice
  network_ingress?: UsageItemPrice_NetworkPrice;
  
  // Prices for license based on memory
  // UsageItemPrice_ServerPrice
  license_memory?: UsageItemPrice_ServerPrice;
  
  // Prices for license based on disk
  // UsageItemPrice_ServerPrice
  license_disk?: UsageItemPrice_ServerPrice;
  
  // Prices for operations based on memory
  // UsageItemPrice_ServerPrice
  operations_memory?: UsageItemPrice_ServerPrice;
  
  // Prices for operations based on disk
  // UsageItemPrice_ServerPrice
  operations_disk?: UsageItemPrice_ServerPrice;
  
  // Prices for cloud based on memory
  // UsageItemPrice_ServerPrice
  cloud_memory?: UsageItemPrice_ServerPrice;
  
  // Prices for cloud based on disk
  // UsageItemPrice_ServerPrice
  cloud_disk?: UsageItemPrice_ServerPrice;
  
  // Price for cloud storage used by backups
  // arangodb.cloud.internal.common.v1.Money
  cloud_object_storage_backup?: arangodb_cloud_internal_common_v1_Money;
  
  // Price for cloud storage used by backups
  // arangodb.cloud.internal.common.v1.Money
  cloud_object_storage_auditlog?: arangodb_cloud_internal_common_v1_Money;
  
  // Price for support plan
  // arangodb.cloud.internal.common.v1.Money
  support_plan?: arangodb_cloud_internal_common_v1_Money;
  
  // Price for outgoing HTTP POST invocations
  // arangodb.cloud.internal.common.v1.Money
  http_post_invocations?: arangodb_cloud_internal_common_v1_Money;
  
  // Price for outgoing HTTP POST body size
  // arangodb.cloud.internal.common.v1.Money
  http_post_body_size?: arangodb_cloud_internal_common_v1_Money;
  
  // Price for addons
  // UsageItemPrice_AddonPrice
  addons?: UsageItemPrice_AddonPrice[];
  
  // IDs or pricing plans used in the calculation of this price.
  // string
  price_plan_ids?: string[];
  
  // Price for memory consumed by the notebook.
  // arangodb.cloud.internal.common.v1.Money
  cloud_memory_notebook?: arangodb_cloud_internal_common_v1_Money;
  
  // Price for disk consumed by the notebook.
  // arangodb.cloud.internal.common.v1.Money
  cloud_disk_notebook?: arangodb_cloud_internal_common_v1_Money;
  
  // Price for license based on notebook resources.
  // arangodb.cloud.internal.common.v1.Money
  license_notebook?: arangodb_cloud_internal_common_v1_Money;
  
  // Price for operations based on notebook resources.
  // arangodb.cloud.internal.common.v1.Money
  operations_notebook?: arangodb_cloud_internal_common_v1_Money;
}
export interface UsageItemPrice_AddonPrice {
  // ID of the addon
  // string
  id?: string;
  
  // Price of the addon
  // arangodb.cloud.internal.common.v1.Money
  amount?: arangodb_cloud_internal_common_v1_Money;
}
export interface UsageItemPrice_NetworkPrice {
  // Price for network traffic with destination internet.
  // arangodb.cloud.internal.common.v1.Money
  internet?: arangodb_cloud_internal_common_v1_Money;
  
  // Price for network traffic with destination in-cluster.
  // arangodb.cloud.internal.common.v1.Money
  cluster?: arangodb_cloud_internal_common_v1_Money;
  
  // Price for network traffic with destination private endpoint.
  // arangodb.cloud.internal.common.v1.Money
  private_endpoint?: arangodb_cloud_internal_common_v1_Money;
}
export interface UsageItemPrice_ServerPrice {
  // Price for agents
  // arangodb.cloud.internal.common.v1.Money
  agents?: arangodb_cloud_internal_common_v1_Money;
  
  // Price for coordinators
  // arangodb.cloud.internal.common.v1.Money
  coordinators?: arangodb_cloud_internal_common_v1_Money;
  
  // Price for dbservers
  // arangodb.cloud.internal.common.v1.Money
  dbservers?: arangodb_cloud_internal_common_v1_Money;
}

// List of usage kinds
export interface UsageKindList {
  // List of usage kinds
  // string
  kinds?: string[];
}

// UsageItemIngestionStatus tracks ingestion of a usage item into Everest (Billing 2.0).
export enum UsageItemIngestionStatus {
  // Not yet sent to Everest (default).
  USAGE_ITEM_INGESTION_STATUS_NOT_INGESTED = 0,
  
  // Sent, awaiting Everest confirmation.
  USAGE_ITEM_INGESTION_STATUS_PENDING = 1,
  
  // Confirmed integrated by Everest.
  USAGE_ITEM_INGESTION_STATUS_INTEGRATED = 2,
  
  // Failed or conflicted; needs attention / retry.
  USAGE_ITEM_INGESTION_STATUS_FAILED = 3,
  
  // Intentionally not ingested (terminal): there is nothing to bill, e.g. a
  // zero-quantity item, so it is skipped instead of priced/sent to Everest.
  USAGE_ITEM_INGESTION_STATUS_SKIPPED = 4,
  
  // Terminal: the usage item's deployment is not billable (free/developer tier, no
  // Everest sales order), so it is never ingested. Distinct from SKIPPED so these are
  // easy to identify and are not re-evaluated every cycle.
  USAGE_ITEM_INGESTION_STATUS_NOT_BILLABLE = 5,
}

// InternalUsageService is the API used to add/update usage items.
export interface IInternalUsageService {
}

// InternalUsageService is the API used to add/update usage items.
export class InternalUsageService implements IInternalUsageService {
}
